import {FixedVTag} from "../../entities/FixedVTag";
import {PagingCtrl} from "../PagingCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";
import {CmdCenterSetPositionFixedModel} from "../../models/cmd/CmdCenterSetPositionFixedModel";
import {NotificationService} from "../../services/NotificationService";

export class CmdCenterSetPositionFixedCtrl extends PagingCtrl<FixedVTag>{
    public static $inject = ['$scope','$location','$state','$stateParams','$uibModalInstance','CmdCenterSetPositionFixedModel','NotificationService','vtagX','vtagY','vtagZ'];
    constructor($scope:any, $location: ng.ILocationService, stateService:StateService,
                stateParamsService:StateParams,
                public modalInstance:angular.ui.bootstrap.IModalServiceInstance,
                public setPositionFixedModel:CmdCenterSetPositionFixedModel,
                public notificationService:NotificationService, vtagX:any,vtagY:any,vtagZ:any) {
        super($scope, $location, stateService, stateParamsService, setPositionFixedModel, notificationService);
        this.setPositionFixedModel.init(parseFloat(vtagX),parseFloat(vtagY), vtagZ);
        this.$scope.$watch(() => this.setPositionFixedModel.selectedFixed,(newValue: any, oldValue: any) => {
          if(newValue != oldValue) {
            this.setPositionFixedModel.selectedVTagType = this.setPositionFixedModel.selectedFixed.vTagType != null ?
              this.setPositionFixedModel.selectedFixed.vTagType : "";
          }
        });
    }

    Ok(){
      if(this.setPositionFixedModel.selectedVTagType === ""){
        this.notificationService.notifyError("V-Tag Type must have a value.");
      }
      else {
        var x = this.setPositionFixedModel.useMeters ? this.setPositionFixedModel.x : this.setPositionFixedModel.x / this.setPositionFixedModel.feetPerMeter;
        var y = this.setPositionFixedModel.useMeters ? this.setPositionFixedModel.y : this.setPositionFixedModel.y / this.setPositionFixedModel.feetPerMeter;
        var fixedTagID = this.setPositionFixedModel.fixedTagID;
        if (fixedTagID != null && fixedTagID.length > 0) {
          var locationId  = this.setPositionFixedModel.selectedLocation != null ? this.setPositionFixedModel.selectedLocation.id : null;
          var fixed: FixedVTag = new FixedVTag(null, this.setPositionFixedModel.fixedTagName, this.setPositionFixedModel.fixedTagID, x, y,
            this.setPositionFixedModel.z, locationId);
          fixed.vTagType = this.setPositionFixedModel.selectedVTagType;
          this.modalInstance.close(fixed);
        }
      }
    }
    Cancel(){
        this.modalInstance.dismiss('cancel');
    }
}
